import "./works.scss"
import LinkIcon from '@mui/icons-material/Link';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { workData} from "../../data";
import { useState } from "react";

export default function Works({theme, setTheme}) {

   const [currentSlide, setCurrentSlide] = useState(0);

  const handleClick = (way) => {
    way === "left" 
    ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 3)
    : setCurrentSlide(currentSlide < workData.length - 1 ? currentSlide + 1 : 0 );
  }

  return (
    <div className={"works "+ (theme && "dark")} id="works">
      <div className="slider"
       style={{ transform: `translateX(-${currentSlide * 100}vw)`}}  >
       { workData.map((d) => (

        <div className="container">

          <div className="item">
           <div className="left">
              <div className="leftContainer">
                <div className="imgContainer">
                
                  <a href={d.link}> <LinkIcon className="img"/></a>
                </div>
                <h2>
                  {d.title}
                </h2>
                <p>
                  {d.desc}
                </p>
                <span>Project!</span>
              </div>
          </div>
          <div className="right">
              <img src={d.img} alt="" />
          </div>

          </div>
          
        </div> ))}
      </div>
      <KeyboardArrowDownIcon className="arrow left"  onClick={() => handleClick("left")}/>
      <KeyboardArrowDownIcon className="arrow right" onClick={() => handleClick()}/>
    </div>
  )
}
